module.exports = __webpack_public_path__ + "img/google-play-badge.f65b85d0.svg";